var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('mu-container',{staticClass:"banner-container",style:({ 'background-image': 'url('+ _vm.url+ '.jpg)' }),attrs:{"fluid":""}},[_c('mu-container',{staticClass:"text-center text-white",staticStyle:{"text-shadow":"2px 2px rgb(23, 23, 23, .3)"}},[_c('h2',[_vm._v(_vm._s(_vm.title))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }